import { render, staticRenderFns } from "./CompanyOrmUtilities.vue?vue&type=template&id=cee2a996&scoped=true"
import script from "./CompanyOrmUtilities.vue?vue&type=script&lang=js"
export * from "./CompanyOrmUtilities.vue?vue&type=script&lang=js"
import style0 from "./CompanyOrmUtilities.vue?vue&type=style&index=0&id=cee2a996&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cee2a996",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cee2a996')) {
      api.createRecord('cee2a996', component.options)
    } else {
      api.reload('cee2a996', component.options)
    }
    module.hot.accept("./CompanyOrmUtilities.vue?vue&type=template&id=cee2a996&scoped=true", function () {
      api.rerender('cee2a996', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/onboarding/CompanyOrmUtilities.vue"
export default component.exports